import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import { motion } from "framer-motion";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  useGetVehicleInformationByIdQuery,
  useGetVehicleInformationDetailQuery,
  useUpdateVehicleInformationMutation,
} from "AppQuries/master/VehicleInformation/vehicleinformation";
import { vehicleInformationValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";

import Vehicle from "./Tab/Vehicle";
import VehicleExpenses from "./Tab/VehicleExpense";
import VehicleMaintenance from "./Tab/VehicleMaintenance";
import DieselUsage from "./Tab/DieselUsage";
import VehicleAccident from "./Tab/Accident";
import VehicleIndemnity from "./Tab/Indemnity";
import { VehicleInformationMapping } from "./VehicleInformationMapping";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
const steps = [
  { id: 0, name: "Information", component: Vehicle },
  { id: 1, name: "Expenses", component: VehicleExpenses },
  { id: 2, name: "Maintenance", component: VehicleMaintenance },
  { id: 3, name: "Diesel", component: DieselUsage },
  { id: 4, name: "Accident", component: VehicleAccident },
  { id: 5, name: "Indemnity", component: VehicleIndemnity },
];

const EditVehicleInformation = () => {
  const userData = useSelector(loggedInUser);
  const [step, setStep] = useState(0);
  const { code } = useParams();
  const {
    data: getVehicleInformation,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetVehicleInformationDetailQuery(
    {
      companyCode: userData?.companyCode,
      code: code,
    },
    {
      enabled: !!code,
    }
  );
  const {
    mutate: updateVehicleInformation,
    isPending,
    isError,
    error,
  } = useUpdateVehicleInformationMutation();

  const methods = useForm({
    defaultValues: {
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      // vehicleInformationList: [
      //   {
      //     createUser: userData?.userName,
      //     createDate: getCurrentFormattedDate(),
      //     modifyUser: getCurrentFormattedDate(),
      //     modifyDate: userData?.userName,
      //   },
      // ],
      // vehicleExpensesList: [
      //   {
      //     createUser: userData?.userName,
      //     createDate: getCurrentFormattedDate(),
      //     modifyUser: getCurrentFormattedDate(),
      //     modifyDate: userData?.userName,
      //     isActive: true,
      //   },
      // ],
    },
    resolver: yupResolver(vehicleInformationValidationSchema),
  });

  const {
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = methods;

  const navigate = useNavigate();

  const onSubmit = (payload) => {
    updateVehicleInformation(payload, {
      onSuccess: (data) => {
        if (data?.result === true) {
          toast.success(
            data?.message || "Vehicle Information Updated Successfully."
          );
          // setTimeout(() => {
          navigate(
            `${all_routes.vechile_master}${all_routes.vehicleinformation}`
          );
          // }, 1000);
        } else {
          toast.warning(data?.message || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error?.message || "Something went wrong.");
      },
    });
  };

  const StepComponent = steps[step].component;

  const moveTo = async (id) => {
    setStep(id);
  };

  const onError = (errors) => {
    // Get the first field with error
    const firstErrorField = Object.keys(errors)[0];
    const tabIndex = VehicleInformationMapping[firstErrorField];

    if (tabIndex !== undefined) {
      setStep(tabIndex);
    }
  };

  useEffect(() => {
    if (
      getVehicleInformation &&
      Object.keys(getVehicleInformation).length > 0
    ) {
      try {
        reset({
          ...getVehicleInformation,
        });
        // Object.entries(getVehicleInformation).forEach(([key, value]) => {
        //   setValue(`vechileInformation[${key}]`, value);
        // });
      } catch (error) {
        console.error("Error setting values:", error);
      }
    }
  }, [getVehicleInformation]);

  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isPending) return <LoadingSpinner />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Edit Vehicle Information</h4>
                  </div>
                </div>

               
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Update Vehicle Information
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
                 <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      // to={`${all_routes.master}${all_routes.vehicleinformation}`}
                      to={`${all_routes.vechile_master}/${all_routes.vehicleinformation}`}
                      className="btn btn-secondary"
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                  <div className="card-body">
                    <ul className="nav nav-tabs nav-tabs-solid nav-justified mb-3">
                      {steps?.map((item, index) => (
                        <li className="nav-item me-0" key={item.id}>
                          <Link
                            className={`nav-link step-${item.id} py-1 ${
                              index === step
                                ? "active"
                                : index < step
                                ? "completed"
                                : "in-completed"
                            }`}
                            id={item.id}
                            type="button"
                            // disabled
                            onClick={() => moveTo(item.id)}
                          >
                            {/* <motion.div
                                                  className={`w-10 h-10 mx-auto flex items-center justify-center font-bold rounded-full transition`}
                                                  initial={{ scale: 0.9 }}
                                                  animate={{ scale: index === step ? 1.1 : 1 }}
                                                  transition={{ duration: 0.9 }}
                                                > */}
                            {item.name}
                            {/* </motion.div> */}
                          </Link>
                        </li>
                      ))}
                    </ul>
                    <div className="tab-content">
                      <motion.div
                        key={step}
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -50 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="tab-pane text-editor add-list">
                          <StepComponent companyCode={userData?.companyCode} />
                        </div>
                      </motion.div>
                      {/* <div className="tab-pane show active" id="tab1">
                                            <Vehicle companyCode={userData?.companyCode} />
                                          </div>
                                          <div className="tab-pane" id="tab2">
                                            <VehicleExpenses />
                                          </div>
                                          <div className="tab-pane" id="tab3">
                                            <VehicleMaintenance />
                                          </div>
                                          <div className="tab-pane" id="tab4">
                                            <DieselUsage />
                                          </div>
                                          <div className="tab-pane" id="tab5">
                                            <VehicleAccident />
                                          </div>
                                          <div className="tab-pane" id="tab6">
                                            <VehicleIndemnity />
                                          </div> */}
                    </div>
                  </div>
                  </div>
                  {/* <div className="card border-0">
                    <div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-solid nav-justified mb-3">
                        <li className="nav-item">
                          <Link
                            className="nav-link active"
                            to="#tab1"
                            data-bs-toggle="tab"
                          >
                            Vechile
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="#tab2"
                            data-bs-toggle="tab"
                          >
                            Vechile Expenses
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="#tab3"
                            data-bs-toggle="tab"
                          >
                            Maintenance
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="#tab4"
                            data-bs-toggle="tab"
                          >
                            Diesel
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="#tab5"
                            data-bs-toggle="tab"
                          >
                            Accident
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="#tab6"
                            data-bs-toggle="tab"
                          >
                            Indemnity
                          </Link>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div className="tab-pane show active" id="tab1">
                          <Vehicle companyCode={userData?.companyCode} />
                        </div>
                        <div className="tab-pane" id="tab2">
                          <VehicleExpenses />
                        </div>
                        <div className="tab-pane" id="tab3">
                          <VehicleMaintenance />
                        </div>
                        <div className="tab-pane" id="tab4">
                          <DieselUsage />
                        </div>
                        <div className="tab-pane" id="tab5">
                          <VehicleAccident />
                        </div>
                        <div className="tab-pane" id="tab6">
                          <VehicleIndemnity />
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditVehicleInformation;
